import React from 'react';
import styled from 'styled-components';
const StyledProgressStepper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .active-or-complete {
    background-color: var(--teal);
    color: white;
  }

  .step-circle {
    border-radius: 50%;
    border: 1px solid var(--text);
    height: 24px;
    width: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .step {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    flex: 1;
    font-size: 0.875rem;
    padding: 0 10px;
  }

  .step p {
    text-align: center;
    margin-bottom: 0;
    font-size: 0.875rem;
  }

  .step .connector {
    position: absolute;
    top: 12px;
    left: calc(-50% + 20px);
    right: calc(50% + 20px);
    border-bottom: 1px solid var(--text);
  }

  @media (max-width: 374px) {
    .step .connector {
      display: none;
    }
  }
`;
;
export const ProgressStepper = ({ activeStepIndex, stepLabels, className }) => (React.createElement(StyledProgressStepper, { className: className || '' }, stepLabels.map((stepLabel, index) => (React.createElement("div", { className: "step", key: `${stepLabel}` },
    React.createElement("div", { className: `step-circle ${index <= activeStepIndex ? 'active-or-complete' : ''}` },
        activeStepIndex <= index && index + 1,
        activeStepIndex > index && React.createElement("i", { className: "far fa-check" })),
    React.createElement("p", null, stepLabel),
    index !== 0 && React.createElement("div", { className: "connector" }))))));
//# sourceMappingURL=ProgressStepper.js.map